export default __webpack_public_path__ + "static/media/shop_hot_2.479a4a41.png";